import * as types from '../mutation-types'

const state = {
	routerName: null,
	routerParam: null,
	modalName: null
}

const getters = {
	modalName: state => state.modalName,
	routerName: state => state.routerName,
	routerParam: state => state.routerParam,
}

const actions = {

}

const mutations = {
	[types.SET_MODAL_NAME] (state, name) {
		state.modalName = name
	},
	[types.SET_ROUTER_NAME] (state, name) {
		state.routerName = name
	},
	[types.SET_ROUTER_PARAM] (state, param) {
		state.routerParam = param
	},
}

export default {
	state,
	getters,
	actions,
	mutations
}
